export default "__VITE_ASSET__DzTNpzCT__"